import * as GoogleAnalyticsConstants from './constants';
import * as D from './deps';
import GoogleAnalyticsWatchers from './sagas/watchers';

export default D.createDomainModule({
  name: 'googleAnalytics',
  actions: null,
  reducer: null,
  constants: GoogleAnalyticsConstants,
  selectors: null,
  components: {},
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(GoogleAnalyticsWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
